import { createFileRoute, redirect } from '@tanstack/react-router'
import { getCurrentUser } from '@/api/auth.api'
import { UsersRolesOptions } from '@/utils/types/pocketbase-types'
import SettingsApplication from '@/features/settings/application'

export const Route = createFileRoute('/_authenticated/settings/')({
  component: SettingsApplication,
  beforeLoad: async () => {
    try {
      const res = await getCurrentUser()
      if (!res?.roles.includes(UsersRolesOptions.Moderateurs)) {
        throw redirect({
          to: '/settings/account',
        })
      }
    } catch (_) {
      throw redirect({
        to: '/settings/account',
      })
    }
  },
})
